import { DefaultValueConfig } from '@headless-workspace/config';
import { Image } from '@headless-workspace/typings';
import { ObjectHelpers, StringHelpers } from '@headless-workspace/utils';
import { ImageDTO } from './ImageDTO';

const getImageUrl = (url?: string) => {
    return url && (StringHelpers.isUrl(url) ? url : DefaultValueConfig.imagePlaceholder);
};

export const mapImage = (dto?: ImageDTO): Image | undefined => {
    if (!dto || ObjectHelpers.isEmpty(dto)) {
        return undefined;
    }

    if ('default' in dto) {
        return {
            src: getImageUrl(dto.default),
            alt: dto.alt ?? DefaultValueConfig.alt,
        };
    }

    const imageWithSizes = {
        alt: dto.alt ?? DefaultValueConfig.alt,
        small: getImageUrl(dto.small),
        medium: getImageUrl(dto.medium),
        large: getImageUrl(dto.large),
    };

    return !imageWithSizes.small && !imageWithSizes.medium && !imageWithSizes.large
        ? {
              src: DefaultValueConfig.imagePlaceholder,
              alt: imageWithSizes.alt,
          }
        : imageWithSizes;
};

export const mapURLToImage = (url?: string | null, alt?: string | null): Image | undefined => {
    if (!url) {
        return undefined;
    }
    return {
        src: getImageUrl(url),
        alt: alt ?? DefaultValueConfig.alt,
    };
};
